"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
var zeroPad_1 = require("./zeroPad");
var monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var dayOfWeekNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
function formatDate(date, patternStr) {
    if (!date)
        return '';
    if (!patternStr) {
        patternStr = 'M/d/yyyy';
    }
    var day = date.getDate(), month = date.getMonth(), year = date.getFullYear(), hour = date.getHours(), minute = date.getMinutes(), second = date.getSeconds(), miliseconds = date.getMilliseconds(), h = hour % 12, hh = (0, zeroPad_1.zeroPad)(h, 2), HH = (0, zeroPad_1.zeroPad)(hour, 2), mm = (0, zeroPad_1.zeroPad)(minute, 2), ss = (0, zeroPad_1.zeroPad)(second, 2), aaa = hour < 12 ? 'AM' : 'PM', EEEE = dayOfWeekNames[date.getDay()], EEE = EEEE.substr(0, 3), dd = (0, zeroPad_1.zeroPad)(day, 2), M = month + 1, MM = (0, zeroPad_1.zeroPad)(M, 2), MMMM = monthNames[month], MMM = MMMM.substr(0, 3), yyyy = "".concat(year), yy = yyyy.substr(2, 2);
    // checks to see if month name will be used
    patternStr = patternStr
        .replace('hh', hh)
        .replace('h', h.toString())
        .replace('HH', HH)
        .replace('H', hour.toString())
        .replace('mm', mm)
        .replace('m', minute.toString())
        .replace('ss', ss)
        .replace('s', second.toString())
        .replace('S', miliseconds.toString())
        .replace('dd', dd)
        .replace('d', day.toString())
        .replace('EEEE', EEEE)
        .replace('EEE', EEE)
        .replace('yyyy', yyyy)
        .replace('yy', yy)
        .replace('aaa', aaa);
    if (patternStr.indexOf('MMM') > -1) {
        patternStr = patternStr.replace('MMMM', MMMM).replace('MMM', MMM);
    }
    else {
        patternStr = patternStr.replace('MM', MM).replace('M', M.toString());
    }
    return patternStr;
}
exports.formatDate = formatDate;
//# sourceMappingURL=dates.js.map